import { parseDocumentFromString } from 'anodum';
import getBlockIdsByElement from '../accessors/get-block-ids-by-element';

const getUsedBlocksFromHTML = (html) => {
  const document = parseDocumentFromString(html);
  return getBlockIdsByElement(document.documentElement);
};

export default getUsedBlocksFromHTML;
